import { useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { Switch } from "@/components/ui/switch";
import { toast } from "sonner";
import { FileText, RotateCcw, Loader2 } from "lucide-react";

export const DEFAULT_PDF_TERMS = "Orçamento válido por 7 dias. Peças e serviços têm garantia conforme o prazo informado nesta OS, contado da data de entrega, e não cobre mau uso, acidentes ou serviços feitos por terceiros. Peças substituídas ficam à disposição do cliente por 30 dias. Após aviso de veículo pronto, o cliente tem 5 dias para retirá-lo; depois desse prazo pode ser cobrada diária de permanência.";

export function PdfTermsCard({ shop, onSaved }) {
  const cfg = shop?.pdf_terms || {};
  const [enabled, setEnabled] = useState(cfg.enabled ?? true);
  const [text, setText] = useState(cfg.text || DEFAULT_PDF_TERMS);
  const [busy, setBusy] = useState(false);
  const save = async () => {
    setBusy(true);
    try { await api.put("/shop-settings/pdf-terms", { enabled, text: text === DEFAULT_PDF_TERMS ? null : text }); toast.success("Termos salvos"); onSaved?.(); }
    catch (e) { toast.error(formatApiError(e)); } finally { setBusy(false); }
  };
  return (
    <section data-testid="pdf-terms-card" className="rounded-2xl border border-card2-border bg-card2 p-5 space-y-3">
      <div className="flex items-center justify-between gap-3">
        <h2 className="flex items-center gap-2 font-display text-lg font-bold uppercase text-zinc-100"><FileText className="h-4 w-4 text-green-brand" /> Termos no PDF</h2>
        <Switch data-testid="pdf-terms-switch" checked={enabled} onCheckedChange={setEnabled} />
      </div>
      <p className="text-xs text-zinc-500">Sai no final do PDF do orçamento e da OS completa (garantia, prazo para retirada etc.).</p>
      <Textarea data-testid="pdf-terms-text" value={text} onChange={(e) => setText(e.target.value)} disabled={!enabled} className="bg-zinc-900 border-zinc-800 text-sm min-h-[130px]" />
      <div className="flex gap-2">
        <Button data-testid="pdf-terms-save" onClick={save} disabled={busy} className="bg-green-brand text-white font-bold uppercase">{busy ? <Loader2 className="h-4 w-4 animate-spin" /> : "Salvar termos"}</Button>
        <Button data-testid="pdf-terms-reset" variant="ghost" disabled={text === DEFAULT_PDF_TERMS} onClick={() => setText(DEFAULT_PDF_TERMS)} className="text-zinc-400"><RotateCcw className="h-3.5 w-3.5 mr-1" /> Texto sugerido</Button>
      </div>
    </section>
  );
}
